import { render, staticRenderFns } from "./configure.vue?vue&type=template&id=2df1c24e&"
import script from "./configure.vue?vue&type=script&lang=ts&"
export * from "./configure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports